const translate =
  window.translate ||
  function (string) {
    return string;
  };

export const fakeJobs = [
  {
    isAccessible: false,
    isBookmarked: false,
    company: translate('Only for registered members'),
    releasedSince: translate('Yesterday'),
    id: 'f1',
    isDeactivated: false,
    isFeatured: false,
    isPromoted: false,
    link: '/job/view/f1',
    source: translate('headhunter'),
    title: translate('Senior Manager'),
  },
  {
    isAccessible: false,
    isBookmarked: false,
    company: translate('Only for registered members'),
    releasedSince: translate('%s days ago', [2]),
    id: 'f2',
    isDeactivated: false,
    isFeatured: false,
    isPromoted: false,
    link: '/job/view/f2',
    source: translate('company'),
    title: translate('Consultant'),
  },
  {
    isAccessible: false,
    isBookmarked: false,
    company: translate('Only for registered members'),
    releasedSince: translate('Yesterday'),
    id: 'f3',
    isDeactivated: false,
    isFeatured: false,
    isPromoted: false,
    link: '/job/view/f3',
    source: translate('Job board'),
    title: translate('Senior Project Manager'),
  },
];

export const fakeHeadhunters = [
  {
    id: 'f1',
    cid: 5745,
    name: 'Michael Page',
    logo: require('@/app/assets/registration-lp/f-headhunter-1.jpg'),
    match: 100,
    jobs: 258,
    activity: 4,
    bookmarked: false,
  },
  {
    id: 'f2',
    cid: 9881,
    name: 'Hays',
    logo: require('@/app/assets/registration-lp/f-headhunter-2.jpg'),
    match: 98,
    jobs: 141,
    activity: 4,
    bookmarked: false,
  },
  {
    id: 'f3',
    cid: 10128,
    name: 'Randstad',
    logo: require('@/app/assets/registration-lp/f-headhunter-3.jpg'),
    match: 96,
    jobs: 97,
    activity: 3,
    bookmarked: false,
  },
];

export const getFakeHeadhunter = (item) => {
  const items = [
    {
      id: 'f1',
      title: 'Michael Page',
      location: 'New York',
      address: '3rd Avenue',
      phone: '1 212 661 4800',
      email: 'newyork@michaelpage.us.com',
      website: 'https://www.michaelpage.com',
      image: require('@/app/assets/registration-lp/f-headhunter-1.jpg'),
      matching: 100,
      offers: 258,
      totalNumberOfJobs: 1763,
      formattedJobsCount: '0',
      formattedTotalJobsCount: '1,763',
      countryCode: 'DE',
      extraData: {
        activityLevel: 4,
        monthsBackToCountActiveJobs: 12,
        topData: {
          channels: {
            1: 'Engineering',
            2: 'IT & Technology',
            3: 'Management &amp; Operations',
          },
          locations: {
            2: 'Berlin',
            3: 'Hamburg',
          },
        },
        channels: {},
        selectedChannels: [],
        channelsList: {},
        activityLevelText: 'very high',
        numberOfJobsPerPeriodText: '> 147 jobs/month',
      },
    },
    {
      id: 'f2',
      title: 'Hays',
      location: 'Mannheim',
      address: 'Willy-Brandt-Platz',
      phone: '+49(621)1788-0',
      email: 'mannheim@hays.de',
      website: 'https://www.hays.de',
      image: require('@/app/assets/registration-lp/f-headhunter-2.jpg'),
      matching: 98,
      offers: 141,
      totalNumberOfJobs: 1763,
      formattedJobsCount: '0',
      formattedTotalJobsCount: '1,763',
      countryCode: 'DE',
      extraData: {
        activityLevel: 4,
        monthsBackToCountActiveJobs: 12,
        topData: {
          channels: {
            1: 'Engineering',
            2: 'IT & Technology',
            3: 'Management &amp; Operations',
          },
          locations: {
            2: 'Berlin',
            3: 'Hamburg',
          },
        },
        channels: {},
        selectedChannels: [],
        channelsList: {},
        activityLevelText: 'very high',
        numberOfJobsPerPeriodText: '> 147 jobs/month',
      },
    },
    {
      id: 'f3',
      title: 'Randstad',
      location: 'Atlanta',
      address: 'Cumberland Blvd',
      email: 'info@us.randstad.com',
      website: 'https://www.randstad.com/',
      image: require('@/app/assets/registration-lp/f-headhunter-3.jpg'),
      matching: 96,
      offers: 97,
      totalNumberOfJobs: 1763,
      formattedJobsCount: '0',
      formattedTotalJobsCount: '1,763',
      countryCode: 'DE',
      extraData: {
        activityLevel: 4,
        monthsBackToCountActiveJobs: 12,
        topData: {
          channels: {
            1: 'Engineering',
            2: 'IT & Technology',
            3: 'Management &amp; Operations',
          },
          locations: {
            2: 'Berlin',
            3: 'Hamburg',
          },
        },
        channels: {},
        selectedChannels: [],
        channelsList: {},
        activityLevelText: 'very high',
        numberOfJobsPerPeriodText: '> 147 jobs/month',
      },
    },
  ];

  return items.find((e) => e.id === item);
};
